<template>
    <div class="opusApply">
        <div class="opusApplyContainer">
            <div class="title">
                本次申请共消耗<b>{{ TotalTimestampsCountCoverDeduction }}个时间戳</b>，<br>确认对该{{ timeData.length }}个文件进行可信时间戳认证？
            </div>
            <div class="fileTable">
                <div class="top">
                    <div class="sec-title">
                        申请文件及费用明细
                    </div>
                    <div class="choose-year" v-if="ossSliceAllUploadNumber>0">
                        <div class="form-item">
                            <label>存储时长：</label>
                            <el-select
                                class="select-year"
                                size="small"
                                v-model="storageYearValue"
                                @change="changeStorageYear"
                            >
                                <el-option
                                    v-for="item in storageYearList"
                                    :key="item.value"
                                    :label="item.title"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                            <el-input-number size="small" v-model="storageYear" @change="changeStorageYearNum" @input.native="handleInputNum($event)" @blur="handleInputNumBlur($event)" :min="1" :max="1000" :precision="0" v-if="storageYearValue===0"></el-input-number> <span v-if="storageYearValue===0">年</span>
                        </div>
                    </div>
                </div>
                <div class="table">
                    <TsaTable
                        ref="TsaTable"
                        :data="timeData"
                        stripe
                        style="width: 100%"
                        class="confirmTable"
                        maxHeight="148"
                        customRowKey="uuid"
                        :row-class-name="tableAddClass"
                    >
                        <el-table-column
                            prop="opusName"
                            label="文件名称"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <el-tooltip
                                    effect="dark"
                                    :content="scope.row.opusName"
                                    placement="bottom"
                                    popper-class="myShadowTooltip"
                                >
                                    <div class="fileName">
                                        <p v-show="!scope.row.modified" class="fileName-p">{{ scope.row.opusName }}</p>
                                        <template v-if="scope.row.solidifySuccess !== 1">
                                            <el-input 
                                                :class="!scope.row.opusNameCheck?'redColor':''" 
                                                v-model="scope.row.opusNameEdit"
                                                v-show="scope.row.modified" 
                                                @keyup.enter.native="subEdit(scope.$index)"
                                            />
                                            <span
                                                @click="editFileName(scope.$index,scope.row)"
                                                v-show="!scope.row.modified"
                                            >
                                                <i class="el-icon-edit-outline"></i>
                                            </span>
                                            <el-button class="editBtn" type="primary" icon="el-icon-check" v-show="scope.row.modified" @click="subEdit(scope.$index)"></el-button>
                                        </template>
                                    </div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="fileType"
                            label="文件类型"
                            width="120"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-dropdown class="dropdown dropdown1" trigger="click" placement="" @command="handleFileType($event,scope)" v-if="scope.row.solidifySuccess!==1">
                                    <span class="el-dropdown-link">
                                        {{ scope.row.fileType | fileTypeToText}}
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-scrollbar class="my-scrollbar is-customed">
                                            <el-dropdown-item :class="scope.row.fileType === item.value ? 'active' : ''" :command="item.value" v-for="item in fileType" :key="item.value">{{ item.name }}</el-dropdown-item>
                                        </el-scrollbar>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <template v-else>{{ scope.row.fileType | fileTypeToText}}</template>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="storeType"
                            label="认证方式"
                            width="100"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-dropdown class="dropdown" trigger="click" placement="" @command="handleCommand($event,scope)" v-if="scope.row.solidifySuccess!==1">
                                    <span class="el-dropdown-link">
                                        {{ scope.row.isUploadFile==false ? '保密认证' : '存证认证'}}
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-scrollbar class="my-scrollbar is-customed">
                                            <el-dropdown-item :class="!scope.row.isUploadFile ? 'active' : ''" :command="1">保密认证</el-dropdown-item>
                                            <el-dropdown-item :class="scope.row.isUploadFile ? 'active' : ''" :command="2">存证认证</el-dropdown-item>
                                        </el-scrollbar>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <template v-else>{{ scope.row.isUploadFile==false ? '保密认证' : '存证认证'}} </template>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="fileSize"
                            label="大小"
                            width="85"
                            align="center"
                        >
                        </el-table-column>
                        <!-- <el-table-column
                            label="文件认证费"
                            width="90"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span :class="{'line':scope.row.solidifySuccess==1}">{{tsCount}} 时间戳</span>
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column
                            label="文件存储费"
                            width="90"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" placement="bottom" popper-class="myShadowTooltip" :disabled="(scope.row.storeCount==0 && !scope.row.isUploadFile)">
                                    <div slot="content" class="info">
                                        <h5>文件存储费</h5>
                                        <p v-if="!scope.row.isUploadFile">本文件为脱敏认证，文件存储免费。</P>
                                        <div v-if="scope.row.isUploadFile">
                                            <dl>
                                                <dt>存证时间：</dt>
                                                <dd>{{currentTime | formatYMD}}</dd>
                                            </dl>
                                            <dl>
                                                <dt>文件存储时长：</dt>
                                                <dd>
                                                    {{scope.row.applyFileSize <= 200 * 1024 * 1024 && scope.row.years<=3 ? 3 : scope.row.years}}年
                                                    <span v-if="scope.row.applyFileSize <= 200 * 1024 * 1024 && scope.row.years<=3">
                                                        （{{currentTime | getFutureDate(3*365)}}存储到期）
                                                    </span>
                                                    <span v-else>
                                                        （{{currentTime | getFutureDate(scope.row.years*365)}}存储到期）
                                                    </span>
                                                </dd>
                                            </dl>
                                            <dl>
                                                <dt>证据大小：</dt>
                                                <dd>{{scope.row.fileSize}}
                                                    <span v-if="scope.row.applyFileSize < 200 * 1024 * 1024">（小于200MB）</span>
                                                    <span v-if="scope.row.applyFileSize ==200 * 1024 * 1024">（等于200MB）</span></dd>
                                            </dl>
                                        </div>
                                        <div class="details" v-if="scope.row.isUploadFile && scope.row.applyFileSize>200 * 1024 * 1024">
                                            <p>
                                                <b>文件存储费</b>= 文件每年存储时间戳消耗数*文件存储时长=<b>{{ scope.row.applyFileSize | getExceptTwoHundred }}*{{scope.row.years}}={{ scope.row.applyFileSize | getConsumptionNum(scope.row.years) }}</b>个时间戳 
                                            </p>
                                            <p>
                                                文件每年存储时间戳消耗数 =<b>「 {{ scope.row.applyFileSize | getMB }}M/200M」</b>=<b>{{ scope.row.applyFileSize | getExceptTwoHundred }}个时间戳</b>
                                            </p>
                                        </div>
                                        <div class="details" v-if="scope.row.isUploadFile && scope.row.applyFileSize<=200 * 1024 * 1024 && scope.row.years<=3">
                                            <p>
                                                文件享受3年免费存储，3年内<b>文件存储费</b>为<b>0</b>个时间戳。
                                            </p>
                                        </div>
                                        <div class="details" v-if="scope.row.isUploadFile && scope.row.applyFileSize<=200 * 1024 * 1024 && scope.row.years>3">
                                            <p>
                                                文件享受3年免费存储，从第4年起，每年收取1个时间戳。
                                            </p>
                                            <p>
                                                <b>文件存储费</b>= 文件每年存储时间戳消耗数*(文件存储时长-3)=<b>1*({{scope.row.years}}-3)={{scope.row.years-3}}</b>个时间戳
                                            </p>
                                        </div>
                                    </div>
                                    <span
                                        class="blue"
                                        :class="{'line':(scope.row.isUploadFile && scope.row.ossSliceUploadSuccess==1) || (!scope.row.isUploadFile && scope.row.solidifySuccess==1)}"
                                    >
                                        {{scope.row.storeCount}}
                                        <span v-if="scope.row.storeCount!==0">时间戳</span>
                                    </span>
                                </el-tooltip>
                            </template>
                        </el-table-column> -->
                        <el-table-column
                            label="费用合计"
                            width="90"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" placement="bottom" popper-class="myShadowTooltip">
                                    <div slot="content" class="info">
                                        <h5>费用合计</h5>
                                        <p>费用合计=文件认证费+文件存储费={{tsCount}}+{{scope.row.storeCount}}={{scope.row.storeCount+tsCount}}个时间戳</p>
                                    </div>
                                    <span 
                                        class="blue"
                                        :class="{'line':(scope.row.isUploadFile && scope.row.ossSliceUploadSuccess==1) || (!scope.row.isUploadFile && scope.row.solidifySuccess==1)}"
                                    >
                                        <span v-if="scope.row.storeCount || scope.row.storeCount==0">
                                            {{(scope.row.storeCount + tsCount)}} 
                                        </span>
                                        <span>时间戳</span>
                                    </span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-tooltip effect="dark" content="删除" popper-class="myShadowTooltip" placement="bottom" v-if="scope.row.solidifySuccess !== 1">
                                    <span class="delBtn">
                                        <i class="el-icon-delete" @click="remove(scope.$index)"></i>
                                    </span>
                                </el-tooltip>
                                <div class="status" v-else>
                                    <div class="shape gray" v-if="scope.row.solidifySuccess==1 && scope.row.isUploadFile && scope.row.ossSliceUploadSuccess!==1">
                                        <p>
                                            <span>已认证</span>
                                            <span>待上传原件</span>
                                        </p>
                                    </div>
                                    <div class="shape green" v-if="(scope.row.solidifySuccess==1 && !scope.row.isUploadFile) || (scope.row.isUploadFile && scope.row.ossSliceUploadSuccess==1)">
                                        <p>
                                            <span>已完成</span>
                                        </p>
                                    </div>
                                </div>
                        </template>
                        </el-table-column>
                    </TsaTable>
                </div>
                <div class="btns">
                    <div class="upload">
                        <span><TsaButton plain @click="chooseFileOrFolder"><i class="el-icon-plus"></i>继续添加</TsaButton></span>
                    </div>
                </div>
                <div class="opusDescribe applicant">
                    <div class="title-wrap">
                        <div class="title-label">
                            <b></b>申请人
                        </div>
                    </div>
                    <div class="real-input">
                        <el-input v-model="form.applicant" placeholder="请输入申请人姓名" disabled></el-input>
                        <span class="realBtn" v-if="opusUserInfo.userType !=='AUTHORIZATION_ACCOUNT'">
                            <span class="goRealName" @click="goReal" v-if="attestationInfo.identificationStatus == 2">去实名</span>
                            <span class="goRealName verified" v-else>已实名</span>
                        </span>
                    </div>
                    <!-- 未实名的主账户 -->
                    <p class="noRealName" v-if="(opusUserInfo.userType !=='AUTHORIZATION_ACCOUNT' && attestationInfo.identificationStatus == 2)">您尚未完成<span class="blue" @click="goReal">实名认证</span>，证书上的"申请人"显示"<b>账号信息</b>"，实名后将显示"<b>实名认证信息</b>"。</p>
                    <!-- 子账号判断 -->
                    <template v-if="opusUserInfo.userType =='AUTHORIZATION_ACCOUNT'">
                        <p class="noRealName" v-if="showNameType==2">
                            根据主账号的权限配置，申请人信息显示<b>子账号名称</b>。为保护主子账号的合法权益，您的"申请人"信息需重新设置，请联系<b>主账号修改</b>。
                        </p>
                        <p class="noRealName" v-else-if="showNameType==0">
                            根据主账号的权限配置，申请人信息显示<b>主账号名称</b>，如需修改请联系主账号。
                        </p>
                        <p class="noRealName" v-else>
                            根据主账号的权限配置，申请人信息显示<b>主账号+子账号名称</b>，如需修改请联系主账号。
                        </p>
                    </template>
                </div>
                <div class="opusDescribe">
                    <div class="title-wrap flex">
                        <div class="title-label">           
                            <b></b>权利人
                        </div>
                        <p class="tip tip2">多个权利人可用“;”分隔输入</p>
                    </div>
                    <div class="description">
                        <el-input v-model="owner" placeholder="请输入权利人姓名或单位名称" @blur="ownerBlur" @focus="ownerFocus" maxlength="50" show-word-limit></el-input>
                    </div>
                </div>
                <div class="opusDescribe">
                    <div class="title-wrap">
                        <div class="title-label">           
                            <b></b>申请人自述声明
                        </div>
                        <p class="tip">为明确权利归属，请仔细确认下方自述声明内容是否真实完整，平台不对该内容进行审核。</p>
                    </div>
                    <div class="description">
                        <el-input
                            type="textarea"
                            v-model="opusDescribe"
                            show-word-limit
                            class="mytextarea"
                            maxlength="300"
                        >
                        </el-input>
                    </div>
                    <div class="explanation">
                        <p>1 自述声明内容模板仅供参考，您可根据具体情况自行修改；</p>
                        <p>2 申请人对申请认证的文件、权利人名称、自述声明承担全部责任，该信息将在《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>认证证书》上展示，平台不进行真实性审查、不承担相关法律责任。</p>
                    </div>
                </div>
                <div class="readRule">
                    <div class="readBox">
                        <h5>
                            <el-checkbox v-model="checked">我已阅读并同意以下内容：</el-checkbox>
                            <!-- <div class="tooltipBox" v-if="tooltipBox">
                                <div class="tipContent">
                                    <p>请先阅读并同意以下内容</p>
                                </div>
                            </div> -->
                        </h5>
                        <p v-if="ossSliceAllUploadNumber>0">
                            <b>1.</b><span>保密认证的文件仅收取基础认证费，存证认证的文件收取基础认证费和文件存储费。详细的收费标准，请您参阅<a @click="goRules">计费规则</a>。</span>
                        </p>
                        <p v-else>
                            <span>保密认证的文件仅收取基础认证费。详细的收费标准，请您参阅<a @click="goRules">计费规则</a>。</span>
                        </p>
                        <p v-if="ossSliceAllUploadNumber>0">
                            <b>2.</b><span>存证认证文件后续收费规则：您存证认证的文件，将在本次存储期满后自动按每年<strong>{{DeductionTimestampsCount}}个时间戳</strong>的标准收取后续存储费用。如扣费时您的时间戳账户余额不足，平台将关闭该存证认证文件下载权限，如需恢复下载权限，请在时间戳账户充值，平台自动扣除存储所需费用。如存证认证文件不再需要平台存储，可在平台上删除存证认证文件，删除后平台不再收取存储费用（建议删除前将存证认证文件下载到本地妥善保存，不可有任何形式修改，否则将无法通过<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>验证，原申请的《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>认证证书》长期有效）。</span>
                        </p>
                    </div>
                </div>
                <div class="upload-input">
                    <input type="file" :accept="isIOS ? 'application/octet-stream':'*/*'" multiple="multiple" ref="inputer"  @change="addfile(1,'inside', form.category)" />
                </div>
            </div>
        </div>
        <div class="operation">
            <span><TsaButton plain @click="close">{{opusFileUploadSuccessNumber==0 ? '取消':'完成认证'}}</TsaButton></span>
            <span><TsaButton @click="submit" :loading="submitting" :disabled="submitting" backGroundColor="linear-gradient( 90deg, #0047FF 0%, #2377FF 100%)">{{ opusFileUploadSuccessNumber==0 ? '确认认证':'继续认证'}}</TsaButton></span>
        </div>

        <!-- 脱敏提示框 -->
        <van-dialog v-model="upTipDia" title="重要提示" class="mydialogBox mydialogBox2" confirmButtonColor="#008AFF" confirmButtonText="知道了" @confirm="closeDia">
            <div class="dialog_cnt">
                <div class="content">
                    <p class="tip" v-if="!isIOS">限于系统特性，若选择“<b>拍照或录像</b>”方式添加文件，在切换为“<b>保密认证</b>”时，该<b>原文件会丢失</b>，请选择其他方式添加文件。</p>
                    <p class="tip" v-else>若希望认证相册中的影像，请先在相册将该影像保存至“文件”系统APP。</p>
                    <p class="check-wrap"><van-checkbox v-model="upTipcCheck" @change="noDiaLog">不再弹出</van-checkbox></p>
                </div>
            </div>
        </van-dialog>

        <!-- 固化弹窗 -->
        <TsaProgressPopUp
            title="正在申请可信时间戳认证"
            ref="solidifyProgressPopUp"
            v-model="opusFilePopup"
            :fileStatus="{
                waiting: '待认证',
                processing: '正在认证',
                success: '认证成功',
                fail: '认证失败',
                showResult: '已认证成功',
                fileDamage: '认证失败',
                realName:'认证失败',
            }"
            percentage="solidifyPercentage"
            success="solidifySuccess"
            width="95%"
            :listData="timeData"
            :uploadSuccessNumber="opusFileUploadSuccessNumber"
            :AllUploadNumber="opusFileAllUploadNumber"
            @on-stop="opusFilePopupStop"
        />
        <van-dialog v-model="opusFileProgressPopupCancelShow" title="提示" class="mydialogBox" show-cancel-button confirmButtonColor="#008AFF" confirmButtonText="确认" cancelButtonText="取消" @confirm="opusFileProgressPopupConfirm" @cancel="opusFileProgressPopupCancel">
            <div class="dialog_cnt">
                <div class="content">
                    <p>关闭后“未认证成功”的文件将不再继续认证，是否确认返回修改</p>
                </div>
            </div>
        </van-dialog>
        <TsaProgressPopUp
            title="正在进行存储"
            ref="ossSliceUploadProgressPopUp"
            v-model="ossUploadPopup"
            :isUpFile="true"
            :fileStatus="{
                waiting: '待上传',
                processing: '正在上传',
                success: '存证成功',
                fail: '存证失败',
                showResult: '已上传成功',
            }"
            percentage="ossSliceUploadPercentage"
            success="ossSliceUploadSuccess"
            width="95%"
            :listData="timeData"
            :uploadSuccessNumber="ossSliceUploadSuccessNumber"
            :AllUploadNumber="ossSliceAllUploadNumber"
            @on-stop="ossUploadPopupStop"
        />
        <van-dialog v-model="ossUploadProgressPopupCancelShow" title="提示" class="mydialogBox" show-cancel-button confirmButtonColor="#008AFF" confirmButtonText="确认" cancelButtonText="取消" @confirm="ossUploadProgressPopupConfirm" @cancel="ossUploadProgressPopupCancel">
            <div class="dialog_cnt">
                <div class="content">
                    <p>关闭后“未上传成功”的文件将不再继续上传，是否确认返回修改</p>
                </div>
            </div>
        </van-dialog>

        <!-- 复选框未勾选弹框 -->
        <van-dialog
            title="请先阅读并同意以下内容"
            v-model="readDialog" 
            width="95%"
            class="readDialog"
            :showConfirmButton="false"
            closeOnClickOverlay
            :beforeClose="closeReadDialog"
            :get-container="getContainer"
        >
            <div class="confirmCnt">
                <div class="tips">
                    <p v-if="ossSliceAllUploadNumber>0">
                        <b>1.</b><span>保密认证的文件仅收取基础认证费，存证认证的文件收取基础认证费和文件存储费。详细的收费标准，请您参阅<a @click="goRules">计费规则</a>。</span>
                    </p>
                    <p v-else>
                        <span>保密认证的文件仅收取基础认证费。详细的收费标准，请您参阅<a @click="goRules">计费规则</a>。</span>
                    </p>
                    <p v-if="ossSliceAllUploadNumber>0">
                        <b>2.</b><span>存证认证文件后续收费规则：您存证认证的文件，将在本次存储期满后自动按每年<strong>{{DeductionTimestampsCount}}个时间戳</strong>的标准收取后续存储费用。如扣费时您的时间戳账户余额不足，平台将关闭该存证认证文件下载权限，如需恢复下载权限，请在时间戳账户充值，平台自动扣除存储所需费用。如存证认证文件不再需要平台存储，可在平台上删除存证认证文件，删除后平台不再收取存储费用（建议删除前将存证认证文件下载到本地妥善保存，不可有任何形式修改，否则将无法通过<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>验证，原申请的《<strong class="timestampR gradientFont">可信时间戳<sup>&reg;</sup></strong>认证证书》长期有效）。</span>
                    </p>
                </div>
                <div class="btn-group">
                    <span class="btn btn-cancel" @click="closeReadDialog">拒绝</span>
                    <span class="btn btn-confirm" @click="submit($event,true)">同意</span>
                </div>
            </div>
        </van-dialog>

        <!-- 上传源文件充值带关闭提示框 -->
        <van-dialog 
            v-model="buyDialog" 
            class="buyDialog" 
            :confirmButtonColor="buyDialogCnt.confirmButtonColor"
            :confirmButtonText="buyDialogCnt.confirmButtonText"
            show-cancel-button
            :cancelButtonText="buyDialogCnt.cancelButtonText"
            :before-close="openbuy"
        >
            <template #title>
                <div class="headerDialog">
                    <h3>{{buyDialogCnt.title}}</h3>
                    <van-icon name="cross" class="close" @click="close" />
                </div>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <p>{{buyDialogCnt.message}}</p>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { mapState,mapActions } from 'vuex'
import {formatYMD} from '@/utils/index'
import { hashFile } from '@/utils/fileHash'
import { ossMultipartUpload,ossAbortMultipartUpload} from '@/utils/ossMultipartUpload.js'
import { encrypt } from '@/utils/aes.js'
import {clearHttp} from '@/common/request.js'
import {apiMe,findBalanceApi} from '@/api/copyright/common'
import {opusApply} from '@/api/service.js'
import {opusUserInfo,generateStsUploadSignMessage,completeStatus,lengthCount,storeCount,cancelStsUpload,getCurrentTime} from '@/api/copyright/copyright'
import opusMixins from '@/mixins/opus/index'
import TsaProgressPopUp from '@/components/ApplyTime/TsaProgressPopUp'
import { calculateMaxFilesOutOfRange } from '@/common/copyright/utils'
import { splitByKeyword } from '@/common/utils.js'
var interval = null;
export default {
    props: {
        tableData: {
            type: Array,
            default: [],
        },
        stageList:{
            type: Array,
            default: [],
        },
        form:{
            type: Object,
            default: {},
        },
        activeStage:{
            type: Number,
            default: '',
        },
    },
    data() {
        return {
            submitting: false,//防止重复提交
            beforText:'',
            afterText:'',
            owner:'',
            oldOwner:'',//保存之前输入的权利人
            ownerInputFocused: false, // 权利人输入框是否获得焦点

            attestationInfo:'',//知产申请人的回显信息和实名状态
            showNameType:'',//账户中心设置的子账号展示名称的形式（主+子等）

            fileOrFolder:false,
            readDialog:false,
            rulesUrl:process.env.VUE_APP_ACCOUNTUI+'/userAccount/norm',
            timeData:[],
            fil:[],
            storageYear: 3,//存储年限
            storageYearValue:3,//存储年限选择值
            DeductionTimestampsCount:0,//存证到期后自动扣除的时间戳数
            checked:false,//是否同意
            //tooltipBox:false,//勾选提示框
            currentTime:new Date().getTime(),//申请存储开始时间（当前）
            storageYearList:[
                {title:'1年', value:1},
                {title:'2年', value:2},
                {title:'3年', value:3},
                {title:'5年', value:5},
                {title:'8年', value:8},
                {title:'10年', value:10},
                {title:'自定义', value:0},
            ],
            buyDialog:false,
            buyDialogCnt:{
                message:'',
                title:'提示',
                confirmButtonColor:"#008AFF",
                confirmButtonText:"去充值", 
                cancelButtonText:"我已充值",
            },
            serialNos:[],
            currentIndex:0,//当前计算hash的索引
            opusFilePopup: false, // 固化文件进度弹窗
            ossUploadPopup: false, // 存证 上传到oss的进度弹窗
            opusFileProgressPopupCancelShow: false,
            ossUploadProgressPopupCancelShow: false,
            ossUploadProgressPopupCancelDisabled: false,
            allowSolidification:true,//是否允许固化
            allowExistingEvidence: true,//是否允许存证
            tsCount:1,
            TotalTimestampsCount: 0,//当前扣除的时间戳总数
            TotalTimestampsCountCoverDeduction:0,//当前时间戳总数包含已扣除的
            solidifyCount:0,//固化扣除的时间戳总数
            existingEvidenceCount:0,//存证扣除的时间戳总数
        }
    },
    components: {TsaProgressPopUp},
    mixins: [ opusMixins ],
    filters: {
        formatYMD,
        getFutureDate(timestamp,days){
            let date = new Date(timestamp);
            let newTimeMs = timestamp + (days * 24 * 60 * 60 * 1000);
            date.setTime(newTimeMs);
            return formatYMD(date);
        },
        getExceptTwoHundred(val){
            return Math.ceil(val/(1024 * 1024)/200)
        },
        getConsumptionNum(val,years){
            return Math.ceil(val/(1024 * 1024)/200)*years
        },
        getFutureDate(timestamp,days){
            let date = new Date(timestamp);
            let newTimeMs = timestamp + (days * 24 * 60 * 60 * 1000);
            date.setTime(newTimeMs);
            return formatYMD(date);
        },
        getMB(val){
            return (val/(1024 * 1024)).toFixed(2)
        },
    },
    computed: {
        ...mapState({
            visualDeviceType: (state) => state.app.visualDeviceType,
            parentIframe: (state) => state.app.parentIframe,
            opusUserInfo: (state) => state.userInfo.userInfo,
        }),
        fileTypeActions(){
            return 
        },
        // 固化时候的成功的数量
        opusFileUploadSuccessNumber() {
            let array = this.timeData.filter((item) => {
                return item.solidifySuccess === 1
            })
            return array.length
        },
        // 固化时候的总数量 (既全量)
        opusFileAllUploadNumber() {
            return this.timeData.length
        },
        // 分片上传成功的数量
        ossSliceUploadSuccessNumber() {
            let array = this.timeData.filter((item) => {
                return item.ossSliceUploadSuccess === 1 && item.isUploadFile === true
            })
            return array.length
        },
        // 分片上传时候的总数量
        ossSliceAllUploadNumber() {
            let array = this.timeData.filter((item) => {
                return item.isUploadFile === true
            })
            return array.length
        },
    },
    created() {
        this.timeData=this.tableData;
        this.owner=this.form.owner;
        this.ownerBlur();
        this.getUserInfo();
        this.init()
    },
    watch: {
        // 权利人值有变化且焦点不在输入框时（程序导致的变化），触发 ownerBlur
        owner(newVal) {
            if (!this.ownerInputFocused && newVal) {
                this.ownerBlur()
            }
        },
        // checked(newVal){
        //     if(newVal){
        //         //this.tooltipBox=false;
        //     }
        // },
        tableData(newVal){
            this.timeData=newVal;
            this.init();
        },
        opusFilePopup(val) {
            if (!val) {
                this.submitting = false
            }
        },
        ossUploadPopup(val) {
            if (!val) {
                this.submitting = false
            }
        }
    },
    mounted() {
        this.scrollBottom();
        document.body.addEventListener('touchstart', function() {}, true);
        // 处理滚动（相当于mouseleave）
        this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.addEventListener('scroll',this.scrollBlur, false);
    },
    beforeDestroy() {
        this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.removeEventListener('scroll',this.scrollBlur);
    },
    methods: {
        goReal(){
            let userAgent = navigator.userAgent.toLowerCase();
            if(userAgent.indexOf('micromessenger') !== -1){//当前页面在微信中打开
                window.location.href=process.env.VUE_APP_ACCOUNTUI+`/userCenter/AuthenticationName/userCenter/AuthenticationName?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
            }else{
                this.$router.push({
                    path:'/mine/Account',
                    query:{
                        url:process.env.VUE_APP_ACCOUNTUI+`/userCenter/AuthenticationName?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType') : 0}`
                    }
                })
            }
        },
        getContainer() {
            return document.querySelector('.main');
        },
        goRecharge(){
            switch (this.parentIframe) {
                case 'ANDROID-RIGHTS':
                    window.testInterface.jumpNativeRecharg(JSON.stringify({copyright:1}));
                    break
                case 'IOS-RIGHTS':
                    window.webkit.messageHandlers.jumpNativeRecharg.postMessage({ copyright:1 });
                    break
                case 'HARMONYOSNEXT-RIGHTS':
                    window.nativeMethod.pushPage('RechargePage', {redirectUrl: 'BannerWebviewPage'});
                    break
                case 'WEIXIN':
                    window.location.href=process.env.VUE_APP_ACCOUNTUI + `/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0}`
                    break
                default:
                    this.$router.push({
                        path:'/mine/Account',
                        query:{
                            url:process.env.VUE_APP_ACCOUNTUI+`/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')?this.$getlocalStorage('partnerType'):0}`
                        }
                    })
            }
        },
        scrollBottom(){
            // 跳到底部操作
            this.$nextTick(() => {
                this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.scrollTop = this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.scrollHeight
            });
        },
        ...mapActions({
            getBalanceInfo: 'balance/getBalanceInfo',
        }),
        closeDia(){
            //初始化将要申请的文件list
            this.$refs.inputer.value= null;
            this.choosefile('inside');
        },
        //点击上传按钮
        chooseFileOrFolder(){
            UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                '操作类型': '弹框_点击上传'
            })
            if (calculateMaxFilesOutOfRange(this.stageList, 'dramaStageFileDraftList')+this.timeData.length >= 1000) {
                this.$TsaToastV2.show({
                    message: '最多支持添加1000个文件',
                    type: 'warn'
                })
                return
            }
            this.upTipcCheck=this.$getlocalStorage('opusNoDia')
            if(!this.upTipcCheck){
                this.upTipDia=true
                return
            }
            //初始化将要申请的文件list
            this.$refs.inputer.value= null;
            this.choosefile('inside');
        },
        // closeFileOrFolder(){
        //     this.fileOrFolder=false;
        //     this.$emit('changeOpcity',false)
        // },

        closeReadDialog(){
            this.readDialog=false;
        },

        async drop(event){
            event.preventDefault();
            event.stopPropagation();
            const filePromises = []
            const items = event.dataTransfer.items
            if(items == undefined){
                this.$toast('当前浏览器不支持拖拽功能，请更换谷歌，火狐等高级浏览器后再使用该功能。')
                return
            }
            this.$TsaLoadingV2.show()
            // 遍历所有拖拽的项目
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                if (item.kind === 'file') {
                    const entry = item.webkitGetAsEntry()
                    if (entry) {
                        // 创建Promise并添加到数组
                        const promise =this.processEntry(entry, this.form.category)
                        filePromises.push(promise)
                    }
                }
            }
            console.log(filePromises)
            Promise.all(filePromises).then((objList) => {
                console.log('文件读取完成')
                this.$TsaLoadingV2.hide()
                this.init()
                this.scrollBottom();
            }).catch((error) => {
                console.error('处理文件时出错:', error)
                this.$TsaLoadingV2.hide();
                if(error.code===1000){
                    this.$TsaToastV2.show({
                        message: '最多支持添加1000个文件',
                        type: 'warn'
                    })
                }else{
                    this.$TsaToastV2.show({
                        message: '文件读取失败',
                        type: 'warn'
                    })
                }
            })    
        },
        
        close(){
            let successCount=this.opusFileUploadSuccessNumber;
            this.timeData=[];
            this.$emit('on-close',{opusFileUploadSuccessNumber:successCount });
        },

        ownerFocus(){
            this.ownerInputFocused = true;
            this.oldOwner = this.owner
            if(this.owner){
                let result= splitByKeyword(this.opusDescribe,'「权利人名称」')
                if(result.length>0){
                    let index= result.findIndex(item => 
                        item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                    )
                    if(index==-1) return
                    this.oldOwner=''
                }
            }
        },
        ownerBlur(){
            this.ownerInputFocused = false;
            if(this.owner && this.opusDescribe){
                let result1 = splitByKeyword(this.opusDescribeText,'「权利人名称」')
                if(!result1.length) return;
                this.beforText=result1[0].before;
                this.afterText=result1[0].after;
                if(this.oldOwner=='') this.oldOwner='「权利人名称」'; 
                let result2= splitByKeyword(this.opusDescribe,this.oldOwner)
                if(result2.length>0){
                    let index= result2.findIndex(item => 
                        item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                    )
                    if(index==-1) return
                    if(result2[index].keyword==this.oldOwner ){
                        this.opusDescribe=(result2[index].before+this.owner+result2[index].after)
                    }
                }
            }
            if(this.owner===''  || this.owner.trim() === ''){
                if(this.oldOwner && this.oldOwner !== '「权利人名称」' && this.opusDescribe){
                    let result = splitByKeyword(this.opusDescribe, this.oldOwner)
                    if(result.length > 0){
                        let index = result.findIndex(item =>
                            item.before.endsWith(this.beforText) && item.after.startsWith(this.afterText)
                        )
                        if(index !== -1){
                            this.opusDescribe = result[index].before + '「权利人名称」' + result[index].after
                        }
                    }
                }
            }
        },

        async init(){
            //从官网获取当前时间
            getCurrentTime().then(res => {
                console.log(res)
                this.currentTime =res
            }).catch(err => {
                this.currentTime=new Date().getTime();
            })
            let paramsData = [];
            this.timeData.forEach((v, i) => {
                paramsData.push({
                    keyType: 0,
                    fileSize: v.applyFileSize,
                    key: v.uuid,
                    years: this.storageYear,
                })
            })
            try {
                let {data,code} = await lengthCount(paramsData)
                if(code==200){
                    this.tsCount = data.tsCount;
                    let resultList = data.resultList;
                    this.timeData = this.timeData.map((item, index) => {
                        let selectData = resultList.find(i => item.uuid == i.key)
                        return {
                            ...item,
                            storeCount: item.isUploadFile ? selectData.storeCount : 0,
                            applyName: this.form.applicant,
                            opusDescribe: this.opusDescribe,
                        }
                    })
                    //获取当前文件的所需时间戳个数
                    this.getConsumptionTimestampsCount();   
                }
            } catch (error) {
                console.log(error)
            }
        },
        //编辑文件名称。
        editFileName(index, item) {
            // 提取文件后缀
            const lastDotIndex = item.opusName.lastIndexOf('.')
            let fileName = item.opusName
            let extension = ''

            if (lastDotIndex !== -1) {
                fileName = item.opusName.substring(0, lastDotIndex)
                extension = item.opusName.substring(lastDotIndex)
            }

            let obj = {
                ...this.timeData[index],
                opusNameEdit: fileName,
                fileExtension: extension,
                modified: true
            }
            this.$set(this.timeData, index, obj)
        },
        //提交编辑文件名称
        subEdit(index) {
            if (this.timeData[index].opusNameEdit.length == 0 || this.timeData[index].opusNameEdit.replace(/\s*/g, "").length == 0) {
                this.$toast('文件名不支持为空')
                return false;
            }
            // 校验长度时需要包含后缀
            const fullName = this.timeData[index].opusNameEdit + (this.timeData[index].fileExtension || '')
            if (fullName.length > 100) {
                this.$toast('文件名最多支持100字符,请修改')
            } else {
                this.timeData[index].opusName = fullName;
                this.timeData[index].modified = false;
                this.timeData[index].opusNameCheck = true;
                let obj = this.timeData[index]
                this.$set(this.timeData, index, obj)
            }
        },
        //删除文件
        remove(index) {
            this.timeData.splice(index, 1);
            this.init();
        },
        // 根据年限改变timeData的数据
        async changeTimeDataYear(){
            let paramsData = [];
            //为未存证成功的文件改变年限
            this.timeData.forEach(item => {
                if(item.isUploadFile && item.ossSliceUploadSuccess!== 1){
                    item.years=this.storageYear;
                    paramsData.push({
                        keyType: 0,
                        fileSize: item.applyFileSize,
                        key: item.uuid,
                        years: item.years,
                    })
                }
            });
            //重新计算未存证成功的文件存储费
            try {
                let {data,code} = await lengthCount(paramsData)
                if(!code==200) return;
                this.tsCount = data.tsCount;
                let resultList = data.resultList;
                this.timeData = this.timeData.map((item, index) => {
                    let selectData = resultList.find(i => item.uuid == i.key)
                    if(selectData){
                        return {
                            ...item,
                            years: selectData.years,              
                            storeCount: item.isUploadFile ? selectData.storeCount : 0,
                        }
                    }else{
                        return item
                    }
                })
                let solidifyCount = this.timeData.filter(item => {
                    return item.solidifySuccess !== 1
                }).length // 需要固化的时间戳数量

                let solidifyCountOver= this.timeData.filter(item => {
                    return item.solidifySuccess == 1
                }).length // 固化完成已扣除的时间戳数量

                let ossSliceUploadOver= this.timeData.filter(item => {
                    return item.ossSliceUploadSuccess == 1
                }) // 固化完成的时间戳数量
                
                //固化完成已扣除的时间戳数量
                let evidenceCountOver=ossSliceUploadOver.reduce((acc, list) => acc + list.storeCount, 0);

                let existingEvidenceCount = 0 // 存证的时间戳数量
                // 计算固化所需要的时间戳
                this.solidifyCount = parseInt((this.tsCount * solidifyCount).toFixed(0))
                // 计算存证所需要的时间戳
                resultList && resultList.map(item => {
                    existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                })
                this.existingEvidenceCount=existingEvidenceCount;
                // 计算时间戳总数
                this.TotalTimestampsCount = parseInt((this.solidifyCount + existingEvidenceCount).toFixed(0))
                //总数包含已扣除的
                this.TotalTimestampsCountCoverDeduction=this.TotalTimestampsCount+evidenceCountOver+solidifyCountOver

            } catch (error) {
                console.log(error)
            }
        },
        //改变存储年限
        changeStorageYear(e){
            if(e!==0){
                this.storageYear=e;
            }
            this.changeTimeDataYear();
        },
        changeStorageYearNum(){
            this.changeTimeDataYear();
        },
        handleInputNum(e){
            let value = e.target.value;
            e.target.value = value.replace(/\D|^0/g, '');
            e.target.value = e.target.value  > 1000 ? 1000 : e.target.value 
        },
        handleInputNumBlur(e){
            let value = e.target.value;
            if(!value){
                e.target.value=3;
                this.storageYear=3;
            }
        },
        //选择类型
        handleFileType(command,scope){
            let obj={
                ...scope.row,
                fileType:command
            }
            this.$set(this.timeData, scope.$index, obj)
            this.init();
        },
        //切换认证方式
        handleCommand(command,scope){
            let obj={
                ...scope.row,
                isUploadFile:command==1?false:true
            }
            this.$set(this.timeData, scope.$index, obj)
            this.init();
        },
        //计算当前提交去掉已存证的剩下的应扣减的时间戳数量详细，用于存证申请提示告知弹框。
        getConsumptionTimestampsCountInfo() {
            return new Promise(async (resolve, reject) => {
                try {
                    let list = []
                    let list2 = []
                    let TotalTimestampsCount = 0 // 总共需要扣除的时间戳数量
                    let TotalTimestampsCountCoverDeduction=0//总共的时间戳数量包含已扣除的
                    let solidifyCount = this.timeData.filter(item => {
                        return item.solidifySuccess !== 1
                    }).length // 需要固化的时间戳数量

                    let solidifyCountOver= this.timeData.filter(item => {
                        return item.solidifySuccess == 1
                    }).length // 固化完成已扣除的时间戳数量

                    
                    let ossSliceUploadOver= this.timeData.filter(item => {
                        return item.ossSliceUploadSuccess == 1
                    }) // 固化完成的时间戳数量
                    
                    //固化完成已扣除的时间戳数量
                    let evidenceCountOver=ossSliceUploadOver.reduce((acc, list) => acc + list.storeCount, 0);

                    let existingEvidenceCount = 0 // 存证的时间戳数量
                    this.timeData.map(item => {
                        //所需要的时间戳参数（扣费用的，只计算未成功的，已成功扣费的不算）
                        if (item.isUploadFile && !item.id) {
                            list.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0,
                                "years": item.years
                            })
                        }
                        //当前所有文件到存证期后需要的存储费用的参数（总数，包含已成功的和未成功的）是每年的续费所以不用传years
                        if (item.isUploadFile) {
                            list2.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0,
                            })
                        }
                    })
                    let {data:{tsCount, resultList}, code:code1 } = await lengthCount(list)
                    if(code1!==200) return
                    let {data:{tsCount:DeductionTimestampsCount}, code:code2 } = await storeCount(list2);
                    if(code2!==200) return
                    // 计算固化所需要的时间戳
                    solidifyCount = parseInt((tsCount * solidifyCount).toFixed(0))
                    // 计算存证所需要的时间戳
                    resultList && resultList.map(item => {
                        existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                    })
                    // 计算时间戳总数
                    TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
                    //总数包含已扣除的
                    TotalTimestampsCountCoverDeduction=TotalTimestampsCount+evidenceCountOver+solidifyCountOver

                    resolve({ TotalTimestampsCount,solidifyCount,existingEvidenceCount,DeductionTimestampsCount,TotalTimestampsCountCoverDeduction})
                } catch (error) {
                    reject(error)
                    callback && callback()
                }
            })
        },
        async getConsumptionTimestampsCount(){
            let {TotalTimestampsCount,solidifyCount,existingEvidenceCount,DeductionTimestampsCount,TotalTimestampsCountCoverDeduction} = await this.getConsumptionTimestampsCountInfo();
            this.DeductionTimestampsCount=DeductionTimestampsCount;
            this.TotalTimestampsCount=TotalTimestampsCount;
            this.solidifyCount=solidifyCount;
            this.existingEvidenceCount=existingEvidenceCount;
            this.TotalTimestampsCountCoverDeduction=TotalTimestampsCountCoverDeduction
        },
        // 计算所需的时间戳
        calculateTheRequiredTimestamp (callback) {
            return new Promise(async(resolve, reject) => {
                try {
                    let list = []
                    let TotalTimestampsCount = 0 // 总共的时间戳数量
                    let solidifyCount = this.timeData.filter(item => {
                        // return (item.storeType === 'DESENSITIZE_STORE' && !item.id) || (item.storeType === 'SAVE_STORE' && item.solidifySuccess !== 1)
                        return item.solidifySuccess !== 1
                    }).length // 需要固化的时间戳数量

                    let existingEvidenceCount = 0 // 存证的时间戳数量
                    this.timeData.map(item => {
                        if (item.isUploadFile && !item.id) {
                            list.push({
                                "key": item.uuid,
                                "fileSize": item.applyFileSize,
                                "keyType": 0,
                                "years": item.years
                            })
                        }
                    })
                    let {code, data:{tsCount, resultList} } = await lengthCount(list)
                    if(code !==200){
                        resolve(0)
                        return 0
                    }
                    // 计算固化所需要的时间戳
                    solidifyCount = parseInt((tsCount * solidifyCount).toFixed(0))
                    // 计算存证所需要的时间戳
                    resultList && resultList.map(item => {
                        existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
                    })
                    // 计算时间戳总数
                    TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
                    resolve(TotalTimestampsCount)
                } catch (error) {
                    console.log(error)
                    reject(error)
                    callback && callback()
                    
                }
            })
        },
        //计算当前应扣减的时间戳数量，用于判断余额是否够用
        getAccountNum(){
            let TotalTimestampsCount = 0 // 总共的时间戳数量
            let solidifyCount = this.timeData.length // 固化的时间戳数量
            let existingEvidenceCount = 0 // 存证的时间戳数量
            let solidifySuccessCount=0 //已固化完成的时间戳数量
            let existingEvidenceSuccessCount=0 //已存证完成的时间戳数量
            // 计算固化所需要的时间戳
            solidifyCount = parseInt((this.tsCount * solidifyCount).toFixed(0))
            // 计算存证所需要的时间戳
            this.timeData.map(item => {
                if(item.solidifySuccess==1){
                    solidifySuccessCount=parseInt((solidifySuccessCount + 1).toFixed(0))
                }
                if(item.ossSliceUploadSuccess==1){
                    existingEvidenceSuccessCount=parseInt((existingEvidenceSuccessCount + item.storeCount).toFixed(0))
                }
                existingEvidenceCount = parseInt((existingEvidenceCount + item.storeCount).toFixed(0)) // 每一次最好取证计算
            })
            // 计算时间戳总数
            TotalTimestampsCount = parseInt((solidifyCount + existingEvidenceCount).toFixed(0))
            //计算应该扣费的时间戳总数
            let deductTimestampsCount=TotalTimestampsCount-existingEvidenceSuccessCount-solidifySuccessCount
            return deductTimestampsCount
        },

        delay (time) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve()
                }, time)
            })
        },
        async submit(e,isRead=false){
            if (this.submitting) return;
            let that=this;
            // 校验申请人
            if(!this.form.applicant || this.form.applicant.trim() === ''){
                this.$TsaToastV2.show({
                    message: '请输入申请人',
                    type: 'error'
                })
                return
            }
            if(this.form.applicant.length > 50){
                this.$TsaToastV2.show({
                    message: '申请人名称不能超过50个字符',
                    type: 'error'
                })
                return
            }
            if(!this.owner || this.owner.trim() === ''){
                this.$TsaToastV2.show({
                    message: '请输入权利人姓名或单位名称',
                    type: 'warn'
                })
                return
            }
            if(this.owner.length > 50){
                this.$TsaToastV2.show({
                    message: '权利人姓名不能超过50个字符',
                    type: 'warn'
                })
                return
            }
            if(!this.opusDescribe || this.opusDescribe.trim() === ''){
                this.$TsaToastV2.show({
                    message: '请输入申请人自述声明',
                    type: 'warn'
                })
                return
            }
            if(this.opusDescribe.length>300){
                this.$message.error('申请人自述声明不能超过300字')
                return
            }
            let P1 = () => {
                return new Promise((resolve, reject) => {
                    let count = 0;
                    let countIndexArray=[];
                    for (let i = 0; i < that.timeData.length; i++) {
                        if(that.timeData[i].modified){
                            that.timeData[i].opusName=(that.timeData[i].opusNameEdit || '') + (that.timeData[i].fileExtension || '');
                            that.timeData[i].modified = false;
                        }
                        if (that.timeData[i].opusName.length > 100) {
                            count++;
                            countIndexArray.push(i);
                            that.timeData[i].opusNameCheck = false;
                            that.timeData[i].modified = true;
                            // 提取文件后缀
                            const lastDotIndex = that.timeData[i].opusName.lastIndexOf('.')
                            if (lastDotIndex !== -1) {
                                that.timeData[i].opusNameEdit = that.timeData[i].opusName.substring(0, lastDotIndex)
                                that.timeData[i].fileExtension = that.timeData[i].opusName.substring(lastDotIndex)
                            } else {
                                that.timeData[i].opusNameEdit = that.timeData[i].opusName
                                that.timeData[i].fileExtension = ''
                            }
                        }
                        that.$set(that.timeData, i, that.timeData[i])
                        if (i == (that.timeData.length - 1)) {
                            if (count > 0) {
                                resolve(countIndexArray)
                            }
                            resolve(countIndexArray);
                        }
                    }
                })
            }
            const countIndexArray = await P1()
            if(countIndexArray.length>0){
                this.$toast('文件名最多支持100字符,请修改');
                this.$nextTick(() => {
                    const targetRow=this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.querySelector(`.el-table__row:nth-child(${countIndexArray[0]+1})`);
                    if (targetRow) {
                        this.$refs.TsaTable.$refs.customizeTableRef.bodyWrapper.scrollTop = targetRow.offsetTop;
                    }
                });
                return
            };

            if(!isRead && !this.checked){
                this.readDialog=true;
                this.$emit('changeOpcity',true)
                return;
            }else{
                this.checked=true;
                this.readDialog=false;
                this.$emit('changeOpcity',false)
            }
            if (this.checked) {
                UserEventRecord.track(UserEventRecord.trackCommonCopyrightProcess, {
                    '操作类型': '确认认证'
                })
            }
            //获取最新实名信息
            this.submitting = true;
            try {
                let applyInfo = await this.getUserInfo(true)
                if(applyInfo.applyName!==this.form.applicant){
                    this.form.applicant=applyInfo.applyName;
                    this.$TsaAlertV2.show({
                        title: '提示',
                        message: '申请人关联实名状态/信息已变更，请确认最新信息后再次申请认证',
                        type: 'warn',
                        confirmButtonText: '去确认',
                        onConfirm: () => {
                            this.$TsaAlertV2.hide()
                        },
                        onClose: () => {
                            this.$TsaAlertV2.hide()
                        },
                    })
                    return
                }
            } catch (error) {
                return
            }
            try {
                let {code,message} = await findBalanceApi(this.getAccountNum());
                if (code == 200) {  //余额够扣给出提示继续下载
                    await this.fileStart({ solidifyType: 1 }) //第一个弹框脱敏认证
                    await this.existingEvidence({ existingEvidenceType: 1}) // 存证 分片上传
                    //let balance = await findBalanceApi(0)
                    this.getBalanceInfo()
                    // 判断是否有 solidifySuccess 为 4 的文件（实名信息变更导致认证失败），有则不关闭弹窗
                    const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                    if (!hasSolidifyFail) {
                        //sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                        this.close();
                    }
                }else if (code == 3010006) { //身份主账号，余额不足
                    this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                    that.$dialog.confirm({
                        title: that.timeStampArrearageMessage(),
                        message: message,
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '去充值',
                        cancelButtonText: '我已充值',
                        beforeClose: (action, done) => {
                            if (action === 'confirm') {
                                UserEventRecord.track(UserEventRecord.trackCommonCopyrightRecharge)
                                that.goRecharge()
                                done();
                            } else {
                                done()
                            }
                        },
                    }).then(() => {
                        console.log('去充值吧')
                    }).catch(async () => {
                        console.log('取消')
                        this.getBalanceInfo()
                    })
                }else if (code == 3010005) { //身份子账号，主账号余额不足
                    this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                    that.$dialog.alert({
                        title:that.timeStampArrearageMessage(), 
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    return false
                }else{ //3010007 身份子账号，主账号分配次数达上限
                    this.$toast('您的时间戳已用完，请联系主账号再次分配。')
                }
            } catch (error) {
                console.log(error)
                if(error && error.name&&error.name=='cancel'){
                    console.log('取消存证')
                }else{
                    // 如果有 solidifySuccess=4 的文件，静默返回（已在 submit 中处理）
                    const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                    if (hasSolidifyFail) {
                        return
                    }
                    //this.$message.error('服务异常，请联系客服')
                }
            } finally {
                this.submitting = false;
            }
        },

        openbuy(action, done){ 
            if (action === 'confirm') {
                UserEventRecord.track(UserEventRecord.trackCommonCopyrightRecharge)
                that.goRecharge();
                done(false)
            } else if(action === 'cancel'){
                done();
            }else{
                if(this.opusFilePopup = true){//当前固化弹框打开，要停止固化
                    //this.opusFilePopupStop()
                    this.opusFileProgressPopupConfirm();
                }
                if(this.ossUploadPopup = true){//当前存证弹框打开，要停止存证
                    // this.ossUploadPopupStop()
                    this.ossUploadProgressPopupConfirm()
                }
                done();
            }
        },
        gobuy(path) {
            this.$router.push({
                path:'/mine/Account',
                query:{
                    url:process.env.VUE_APP_ACCOUNTUI+path
                }
            })
        },

        // 1.开启文件固化程序先脱敏扣费弹框 solidifyType 正常固化值为 1， 点击结束固化弹窗中的取消按钮，执行的接续固化 值为 2
        async fileStart({ solidifyType }) {
            return new Promise(async (resolve, reject) => {
                let obj;
                let hasUpload;//list中是否有存证的项
                try {
                    if (this.opusFileUploadSuccessNumber === this.opusFileAllUploadNumber) {
                        clearInterval(interval) // 结束保活
                        interval = null // 结束保活
                        this.opusFilePopup = false // 关闭弹窗
                        resolve()
                        return
                    }
                    // 进行保活处理
                    interval = setInterval(()=> {
                        apiMe().then((res) => {
                            console.log('正在保活')
                        }).catch((err) => {
                            console.log(err)
                        });
                    }, 60000);
                    this.allowSolidification = true
                    if (solidifyType === 1) {
                        this.timeData.map(item => {
                            if (item.solidifySuccess !== 1) {
                                item.solidifyPercentage = 0
                                item.solidifySuccess = 0
                            }
                        })
                    }
                    this.opusFilePopup = true
                    await this.delay(0) // 用来代替 nextTick
                    this.$refs.solidifyProgressPopUp.initScroll()
                    for (let i = 0; i < this.timeData.length; i++) {
                        obj = this.timeData[i]
                        this.$refs.solidifyProgressPopUp.autoScroll(obj.uuid)
                        if ((solidifyType === 1 && obj.solidifySuccess !== 1) || (solidifyType === 2 && obj.solidifySuccess === 0)) { // 如果是再次固化的需要去除 固化失败的
                            this.currentIndex = i // 设置当前索引
                            let { isUploadFile } = obj
                            let reader;
                            let fileHash = await hashFile(obj.fileItem, 'SHA256', (percentage) => {
                                if (this.allowSolidification === false) { // 固化结束
                                    reader && reader.abort()
                                    reader = null
                                    return
                                }
                                obj.solidifyPercentage = percentage
                            }, ({ reader }) => {
                                reader = reader
                                if (this.allowSolidification === false) { // 固化结束
                                    reader && reader.abort()
                                    reader = null
                                    return
                                }
                            }, 1)
                            if(fileHash===null){
                                obj.solidifySuccess = 3;
                            }else{
                                obj.fileHash = fileHash;
                                obj.businessSubType = this.form.type === 1 ? 1 : 2;
                                // console.log('第一步的hash', sha256)
                                if (this.allowSolidification === false) return
                                obj.opusDescribe=this.opusDescribe;
                                obj.owner=this.owner;
                                obj.applyName=this.form.applicant;
                                // let {data,code:code1}=await opusApply(obj)
                                // if(code1 !== 200) {
                                //     reject()
                                //     return
                                // };
                                // let {code, id, message, serialNo,operatedAt} = data;

                                let res=await opusApply(obj)
                                let {code, id, message, serialNo,operatedAt } = res;

                                if (code === 9523100) { //固化成功
                                    // obj.md5 = CryptoJs.enc.Base64.stringify(md5)
                                    obj.serialNo = serialNo
                                    this.serialNos.push(serialNo);
                                    if (!isUploadFile) { // 如果是脱敏的 认为是固化成功
                                        obj.id = id
                                    }
                                    //调用阶段文件添加接口
                                    this.$emit('addStageFile',{
                                        id,
                                        opusName:obj.opusName,
                                        operatedAt,
                                        fileType:obj.fileType
                                    })
                                    obj.solidifySuccess = 1
                                    this.timeData[i]=obj
                                    this.$set(this.timeData, i, obj)
                                    this.getBalanceInfo()
                                    // let balance = await findBalanceApi(0)
                                    // this.$store.commit('UserInfo/getBalanceInfo', balance)
                                } else {
                                    if (await this.solidifyFail(code, obj, message)) {
                                        return
                                    }
                                }
                            }
                            //如果没有存证的，那么只有固化一个弹框，判断当前是最后一个并且已完成固化，直接跳成功页。
                            if(this.opusFileProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.solidifySuccess == 1 && !hasUpload){
                                // 判断是否有 solidifySuccess 为 4 的文件，有则刷新申请人信息而非关闭弹窗
                                const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                                if (hasSolidifyFail) {
                                    this.getUserInfo()
                                } else {
                                    //sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                    this.close()
                                }
                                return
                            }
                            // 如果弹出了取消固化的弹窗，就自动停止，不进入下一个循环
                            if (this.opusFileProgressPopupCancelShow === true) return
                        }
                    }
                    await this.delay(1000) // 如果此时结束了固化
                    console.log('固化结束')
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    for (let i = 0; i < this.timeData.length; i++) {
                        if (this.timeData[i].solidifySuccess === 3) {
                            this.timeData.splice(i, 1)
                            i--
                        }
                    }
                    if (this.opusFileUploadSuccessNumber === this.opusFileAllUploadNumber) {
                        this.opusFilePopup = false // 关闭弹窗
                        console.log('****************')
                        // if (this.allowSolidification === true) { // 允许固化的时候固化
                        //     callback && callback()
                        // }
                        resolve()
                    } else {
                        console.log('------solidify-----has---fail---')
                        reject()
                    }
                } catch (error) {
                    console.log(error)
                    console.log('------solidify-----error---')
                    obj.solidifySuccess = 2 
                    reject(error)
                }
            })
        },
        async solidifyFail (code, obj, message) {
            obj.solidifySuccess = 2;
            if (code === 9523101) { // 固化失败了
                //obj.solidifySuccess = 2
                return false
            }else if(code === 9523103){//实名信息变化
                obj.solidifySuccess = 4
                return false
            } else if (code === 10001) { 
                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                if(this.userInfo.userType === 'ADMIN_ACCOUNT') { // 主账号
                    this.buyDialog=true;
                    this.buyDialogCnt.title=this.timeStampArrearageMessage();
                    this.buyDialogCnt.message=message;
                    this.opusFilePopup = false
                    this.opusFileProgressPopupCancelShow = false
                    return true
                } else {
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(), 
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    this.opusFilePopup = false
                    this.opusFileProgressPopupCancelShow = false
                    return true
                }
            } else {
                this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
                // 10013 子账号超出最大限额
                this.$dialog.alert({
                    title:this.timeStampArrearageMessage(),
                    message:message, 
                    confirmButtonColor:'#008AFF',
                    confirmButtonText: '我知道了',
                })
                this.opusFilePopup = false
                this.opusFileProgressPopupCancelShow = false
                return true
            }
        },
        //固化过程中，点击取消显示的弹窗
        opusFilePopupStop () {
            this.opusFileProgressPopupCancelShow = true
        },
        //固化过程中，点击取消
        async opusFileProgressPopupCancel () {
            let currentObj = this.timeData[this.currentIndex]
            // 如果结束固化的过程中存在 hash算完并且 opusApply 还没处理完的情况下
            if (currentObj.solidifyPercentage === 100 && currentObj.solidifySuccess === 0) {
                this.$message({
                    message: '当前文件即将认证成功，请稍后处理',
                    type: 'warning'
                });
            } else {
                this.opusFileProgressPopupCancelShow = false // 关闭弹窗 （必须先关闭）
                // 如果点击取消的时候，流程没有进入固化 代码继续往下走，如果已经进入了固化接口，那么执行下面的函数，重新执行固化函数，继续固化
                if (currentObj.solidifySuccess !== 0) {
                    await this.fileStart({ solidifyType: 2 })
                    await this.existingEvidence({ existingEvidenceType: 2 })
                }
            }
        },
        //固化过程中，点击确定结束固化
        opusFileProgressPopupConfirm () {
            let currentObj = this.timeData[this.currentIndex]
            // 如果结束固化的过程中存在 hash算完并且 opusApply 还没处理完的情况下
            if (currentObj.solidifyPercentage === 100 && currentObj.solidifySuccess === 0) {
                this.$message({
                    message: '当前文件即将认证成功，请稍后处理',
                    type: 'warning'
                });
            } else {
                clearInterval(interval) // 结束保活
                interval = null // 结束保活
                //this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                clearHttp()
                this.allowSolidification = false
                this.opusFilePopup = false
                this.opusFileProgressPopupCancelShow = false
                // 刷新申请人信息（可能因实名信息变更导致固化失败）
                this.getUserInfo()
            }
        },
        // 2.全部脱敏扣费后再继续存证上传扣费
        async existingEvidence ({ existingEvidenceType }) {
            return new Promise(async (resolve, reject) => {
                console.log(this.ossSliceUploadSuccessNumber+'----'+this.ossSliceAllUploadNumber)
                if (this.ossSliceUploadSuccessNumber === this.ossSliceAllUploadNumber) {
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    this.ossUploadPopup = false // 有改动
                    resolve()
                    return
                }
                let obj;
                // 需要判断钱是否够
                try {
                    // 进行保活处理
                    interval = setInterval(()=> {
                        apiMe().then((res) => {
                            console.log('正在保活')
                        }).catch((err) => {
                            console.log(err)
                        });
                    }, 60000);
                    this.allowExistingEvidence = true
                    if (existingEvidenceType === 1) {
                        this.timeData.map(item => {
                            if (item.ossSliceUploadSuccess !== 1 && item.isUploadFile) {
                                item.ossSliceUploadPercentage = 0
                                item.ossSliceUploadSuccess = 0
                            }
                        })
                    }
                    this.ossUploadPopup = true
                    await this.delay(0) // 用来代替 nextTick
                    this.$refs.ossSliceUploadProgressPopUp.initScroll()
                    for (let i = 0; i < this.timeData.length; i++) {
                        obj = this.timeData[i]
                        if (obj.isUploadFile && ((existingEvidenceType === 1 && !obj.id) || (existingEvidenceType === 2 && obj.ossSliceUploadSuccess === 0) )) {
                            this.currentIndex = i
                            this.$refs.ossSliceUploadProgressPopUp.autoScroll(obj.uuid)
                            let { fileHash, serialNo, fileItem, applyFileSize,years } = obj
                            if (this.allowExistingEvidence === false) return
                            let { data:{accessKey, secretKey, secretToken, bucket, key , storeId}} = await generateStsUploadSignMessage(encrypt({
                                serialNo, 
                                applyFileSize,
                                years,                                
                            }), 'nqio8Mem5oDNNBxOStIAlIsxrtWAx/c8')
                            obj.storeId = storeId
                            if (this.allowExistingEvidence === false) return                           
                            try {
                                await ossMultipartUpload({
                                    fileHash,
                                    accessKey,
                                    secretKey,
                                    secretToken,
                                    bucket,
                                    key,
                                    file:fileItem,
                                }, ({ percentage }) => {
                                    obj.ossSliceUploadPercentage = percentage
                                })
                            } catch (error) {
                                //文件完整性校验未通过 (MD5 不匹配)'
                                if(error.code === 'InvalidDigest'){
                                    this.$toast('文件完整性校验未通过')
                                    obj.ossSliceUploadSuccess = 2 // 上传失败
                                    try {
                                        // 删除oss上校验失败的文件
                                        await cancelStsUpload({
                                            serialNo: obj.serialNo,
                                            storeId: obj.storeId,
                                        })
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }else{
                                    //this.$toast('当前文件上传失败')
                                    obj.ossSliceUploadSuccess = 2 // 上传失败                                 
                                }
                                this.timeData[i]=obj;
                                this.$set(this.timeData, i, obj)
                                if(this.ossUploadProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.ossSliceUploadSuccess == 1){//再点取消的时候，最后一个已经存证完成，那就直接跳转到成功页
                                    // 判断是否有 solidifySuccess 为 4 的文件，有则不关闭弹窗
                                    const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                                    if (!hasSolidifyFail) {
                                        this.close()
                                    }
                                    return
                                }
                                continue;
                            }
                            if (this.allowExistingEvidence === false) return
                            let { id } = await this.ossSliceUploadGetStatus({serialNo,storeId})
                            if (id) { 
                                obj.ossSliceUploadSuccess = 1 // 上传成功
                                obj.id = id
                            } else {
                                obj.ossSliceUploadSuccess = 2 // 上传失败
                            }
                            this.timeData[i]=obj;
                            this.$set(this.timeData, i, obj)
                            if(this.ossUploadProgressPopupCancelShow === true && (i == this.timeData.length-1) && obj.ossSliceUploadSuccess == 1){//再点取消的时候，最后一个已经存证完成，那就直接跳转到成功页
                                // 判断是否有 solidifySuccess 为 4 的文件，有则不关闭弹窗
                                const hasSolidifyFail = this.timeData.some(item => item.solidifySuccess === 4)
                                if (!hasSolidifyFail) {
                                    //sessionStorage.setItem('serialNos',JSON.stringify(this.serialNos));
                                    this.close()
                                }
                                return
                            }
                            if (this.ossUploadProgressPopupCancelShow === true) return
                        }
                    }
                    await this.delay(1000) // 1秒后结束固化
                    clearInterval(interval) // 结束保活
                    interval = null // 结束保活
                    if (this.ossSliceUploadSuccessNumber === this.ossSliceAllUploadNumber) {
                        this.ossUploadPopup = false
                        resolve()
                    } else {
                        reject()
                    }
                } catch (error) {
                    console.log(error)
                    if(error.status === 400){
                        let { code, message } = error.data
                        this.existingEvidenceFail(code, obj, message)
                    }
                    reject(error)
                }
            })
        },
        // 查询最新的存证状态
        ossSliceUploadGetStatus ({serialNo,storeId}, onOff) {
            console.log(serialNo);
            return new Promise((resolve, reject) => {
                let time = null;
                clearTimeout(time)
                const getStatus = ({ serialNo, storeId }) => {
                    if (this.allowExistingEvidence === false && !onOff) {
                        resolve({})
                        return
                    }
                    completeStatus({bid:serialNo,serialNo,storeId}).then(async res => {
                        if (this.allowExistingEvidence === true || onOff) {
                            let {data,code}=res
                            if(code !== 200){
                                resolve({})
                                clearTimeout(time)
                                time = null
                                return
                            }
                            if (data.sourceFileUploadType === 0) { // 状态没有更新，继续轮询
                                time = setTimeout(() => {
                                    getStatus({ serialNo, storeId })
                                }, 1000)
                            } else {
                                resolve(data)
                                clearTimeout(time)
                                time = null
                                this.getBalanceInfo()
                                // let balance = await findBalanceApi(0)
                                // this.$store.commit('UserInfo/getBalanceInfo', balance)
                            }
                        } else {
                            resolve({})
                            clearTimeout(time)
                            time = null
                        }
                    }).catch((error) => {
                        resolve({})
                        clearTimeout(time)
                        time = null
                    })
                }
                getStatus({ serialNo, storeId })
            })
        },
        timeStampArrearageMessage (message) {
            return '本次申请需要消耗时间戳 ' + this.TotalTimestampsCount + ' 个'
            //return '<div class="timeStampArrearage"><h4>本次申请需要消耗时间戳 ' + this.TotalTimestampsCount + ' 个</h4>' + message + '</div>'
        },
        // 存证失败
        async existingEvidenceFail (code, obj, message) {
            // code 2 您的主账号余额不足，请联系主账号充值
            // code 3 您的使用个数已达上限，请联系主账号分配
            // code 4 您的余额不足，请充值后在使用
            message = message || '系统错误'
            this.ossUploadPopup = false // 关闭存证进度弹窗
            this.ossUploadProgressPopupCancelShow = false // 关闭结束存证的弹窗（会出现，几率很小）
            obj.ossSliceUploadSuccess = 2
            clearInterval(interval) // 清空保活接口
            interval = null
            this.TotalTimestampsCount = await this.calculateTheRequiredTimestamp()
            switch (code) {
                case 2:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    break
                case 3:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
                    break
                case 4:
                    this.buyDialog=true;
                    this.buyDialogCnt.title=this.timeStampArrearageMessage()
                    this.buyDialogCnt.message=message;
                    break
                default:
                    this.$dialog.alert({
                        title:this.timeStampArrearageMessage(),
                        message:message, 
                        confirmButtonColor:'#008AFF',
                        confirmButtonText: '我知道了',
                    })
            }
        },
        //存证过程中，点击取消显示的弹窗
        ossUploadPopupStop () {
            this.ossUploadProgressPopupCancelShow = true
        },
        //存证过程中，点击结束存证
        async ossUploadProgressPopupConfirm () {
            try {
                this.ossUploadProgressPopupCancelDisabled = true // 禁止重复点击
                let currentObj = this.timeData[this.currentIndex]
                if (currentObj.isUploadFile && currentObj.ossSliceUploadPercentage === 100 && currentObj.ossSliceUploadSuccess === 0) {
                    this.$message({
                        message: '当前文件即将上传成功，请稍后处理',
                        type: 'warning'
                    });
                } else {
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    // 这里可能还需要清除一个定时器
                    this.allowExistingEvidence = false // 存证不允许
                    // 如果上传成功的都不允许删除
                    if (currentObj.ossSliceUploadPercentage < 100) {
                            await ossAbortMultipartUpload() // 取消oss请求
                            // 需要调用终止分片的接口 （已经上传到服务器的就不能被取消了）
                            await cancelStsUpload({
                                serialNo: currentObj.serialNo,
                                storeId: currentObj.storeId,
                            })
                        }
                    //this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    clearHttp()
                    this.ossUploadPopup = false
                    this.ossUploadProgressPopupCancelShow = false
                }
                this.ossUploadProgressPopupCancelDisabled = false // 禁止重复点击
            } catch (error) {
                if (error && error.status === 400 && error.config && error.config.url === '/drama/api/opus/cancelStsUpload') {
                    this.allowExistingEvidence = true
                    let { id } = await this.ossSliceUploadGetStatus({serialNo,storeId}, true)
                    if (id) {
                        currentObj.ossSliceUploadSuccess = 1 // 上传成功
                        currentObj.id = id
                        currentObj.ossSliceUploadPercentage = 100 // 成功
                    } 
                    await this.existingEvidence({ existingEvidenceType: 2 })
                } else {
                    //await ossAbortMultipartUpload() // 取消oss请求
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    this.allowExistingEvidence = false // 存证不允许
                    this.ossUploadProgressPopupCancelDisabled = false // 禁止重复点击
                    clearHttp()
                    //this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    this.ossUploadPopup = false
                    this.ossUploadProgressPopupCancelShow = false
                }
            }
        },
        async ossUploadProgressPopupCancel () {
            let currentObj = this.timeData[this.currentIndex]
            if (currentObj.isUploadFile && currentObj.ossSliceUploadPercentage === 100 && currentObj.ossSliceUploadSuccess === 0) {
                this.$message({
                    message: '当前文件即将上传成功，请稍后处理',
                    type: 'warning'
                });
            }else{
                this.ossUploadProgressPopupCancelShow = false // 关闭弹窗 （必须先关闭）
                // 如果点击取消的时候，流程没有进入存证 代码继续往下走，如果已经进入了存证接口，那么执行下面的函数，重新执行固化、、存证函数，继续存证
                if (currentObj.isUploadFile && currentObj.ossSliceUploadSuccess !== 0) {
                    await this.existingEvidence({ existingEvidenceType: 2 })
                }
            }
        },

        //为已认证过的文件置灰
        tableAddClass({row,rowIndex}){
            if (row.solidifySuccess==1) {
                return 'disabled-row';
            }
            return '';
        },

        goRules(){
            this.$emit('showRules')
        }
    },
}
</script>

<style src='./css/OpusApply.scss' lang='scss' scoped></style>
<style lang='scss'>
    .my-scrollbar{
        max-height: 200px;
        width: 100%;
        overflow-y: auto;
        &.is-customed {
            .el-dropdown-menu__item {
                &.active {
                    // background-color: #e6effd;
                    color: #337deb;
                }
                &:hover {
                    background-color: #e6effd;
                    color: #337deb;
                }
            }
        }
        .el-scrollbar__wrap{
            overflow: hidden;
        }
    }
    
    
</style>